import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import ImageText from '../common/imageText';
import ImageButtonList from '../common/imageButtonList';
import NavigationBar from '../common/navigationBar';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { withRouter } from 'react-router-dom';

class Service1343 extends Component {
  /**************
   * Properties *
   **************/
  state = {
    currentPatient: this.props.currentPatient,
  }
   allergiesBkg = {
    id: 'text',
    src: require('./images/Allergies_elements.png')
  };
  medsBkg = {
    id: 'text',
    src: require('./images/Medications_elements.png')
  };
  defaultAllergies = {
    id: 'text',
    src: require('./images/Allergies_elements.png')
  };
  defaultMeds = {
    id: 'text',
    src: require('./images/Medications_elements.png')
  };
  orthoAllergies = {
    id: 'text',
    src: require('./images/Allergies_elements.png')
  };
  orthoMeds = {
    id: 'text',
    src: require('./images/Medications_elements.png')
  };
  chfAllergies = {
    id: 'text',
    src: require('./images/1343_CHF_MyAllergies.png')
  };
  pediatricAllergies = {
    id: 'text',
    src: require('./images/1343_pediatric_MyAllergies.png')
  };
  chfMeds = {
    id: 'text',
    src: require('./images/1343_CHF_MyMedications.png')
  };
  buttonList = {
    top: 219,
    left: 750
  };
  buttons = [
    {
      id: 'continue',
      to: '/main_menu',
      highlight: require('./images/continue_HL.png'),
      alt: 'Continue'
    }
  ];
  navigationBar = {
    mainMenu: false,
    back: false,
    backRoute: null
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    let patientMeds = null;
    switch(this.state.currentPatient) {
      case 'orthoPatient':
          patientMeds = this.orthoMeds
        break;
      case 'chfPatient':
          patientMeds = this.chfMeds
        break;
      default:
          patientMeds = this.defaultMeds
    }
    let patientAllergies = null;
    switch(this.state.currentPatient) {
      case 'orthoPatient':
          patientAllergies = this.orthoAllergies
        break;
      case 'chfPatient':
          patientAllergies = this.chfAllergies
        break;
      case 'pediatricPatient':
          patientAllergies = this.pediatricAllergies
        break;
      case 'oncologyPatient':
          // same as pediatric
          patientAllergies = this.pediatricAllergies
        break;
      default:
          patientAllergies = this.defaultAllergies
    }
    return (
      <div className="service-1343">
        <Switch>
          <Route
            path="/info_confirmation/allergies"
            render={routeProps => (
              <InfoDisplay
                {...routeProps}
                text={patientAllergies}
                buttonList={this.buttonList}
                buttons={this.buttons}
                navigationBar={this.navigationBar}
              />
            )}
          />
          <Route
            path="/info_confirmation/meds"
            render={routeProps => (
              <InfoDisplay
                {...routeProps}
                text={patientMeds}
                buttonList={this.buttonList}
                buttons={this.buttons}
                navigationBar={this.navigationBar}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

const ConnectedService1343 = connect(
  state => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(Service1343);

export default withRouter(ConnectedService1343);

class InfoDisplay extends Component {
  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div>
        <ImageBackground id="background" />
        <ImageText {...this.props.text} />
        <ImageButtonList {...this.props.buttonList} imageButtons={this.props.buttons} />
        <NavigationBar {...this.props.navigationBar} />
      </div>
    );
  }
}
